// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail {
  text-align: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
  margin: auto;
}

.folder-section .thumbnail {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 1rem;
  text-align: left;
}

.thumbnail:hover {
  font-weight: 600;
}

.thumbnail:hover .media-delete {
  opacity: 1;
}

.folder-section .thumbnail .thumbnail-icon {
  margin-top: 1rem;
  color: #fff;
  position: relative;
  display: inline-block;
  width: 70%;
}

.thumbnail .media-delete {
  position: absolute;
  right: 0.75rem;
  opacity: 0;
  transition: all ease-in-out 0.2s;
  background: white;
  border-radius: 0 50px 50px 0;
  box-shadow: 2px 1px 2px 0px #cecece;
  right: 18px;
  top: 0;
}

.thumbnail .thumbnail-image {
  flex-grow: 1;
  max-width: 100%;
  object-fit: cover;
  border: 2px solid #fff;
  border-bottom: none;
  background: #fff;
  padding: 0.25rem;
  height: 130px;
  width: 130px;
}

.thumbnail .thumbnail-text {
  margin: 0;
  padding: 0.25rem 1rem;
  text-align: center;
  overflow: hidden;
  color: #fff;
  height: 3em;
}

.files-section .thumbnail .thumbnail-text {
  color: black;
}

.folder-section {
  background: #343a40;
  width: 100%;
  position: absolute;
  bottom: 0;
  top: 55px;
  right: 0;
}

.menu-text {
  color: #fff;
}

.add-new-comp {
  background: #7e55b3;
  border: 0px !important;
  padding: 0.5em !important;
  width: 100%;
  color: #fff;
  border-radius: 10px;
}

.folder-icon {
  font-size: 24px;
}

.folder-delete {
  display: inline-block;
  float: right;
  padding: 20px;
}

.folder-delete>i {
  color: white;
}

.plus-btn {
  left: 9rem;
  border: none;
  outline: none;
}

::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  /* border-top-width: 5px !important; */
  padding: 0px !important;
}

.card-margin {
  margin: 15px;
}

/* .custom-container{

} */

.mat-card {
  padding: 0px;
}

.mat-card-actions, .mat-card-content, .mat-card-subtitle {
  padding: 16px;
  margin: 16px;
}

.custom-card-header {
  background-color: #7e55b3;
  color: white;
  padding: 10px 0px 0px 10px;
}

.custom-title {
  font-weight: bold;
  font-size: 15px;
}

.dorp-zone-media {
  border: 1px dashed rgb(0, 161, 255);
  height: 120px;
  width: 130px;
  margin: 8px 30px 30px 30px;
  overflow-x: inherit;
  text-align: center;
}

.alert-warning {
  color: #856404;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  WIDTH: fit-content;
}

 
::ng-deep .categories-tags ng-select.ng-invalid.ng-touched .ng-select-container {
  border-color: #dc3545;
  animation-name: flush;
  animation-duration: 0.7s;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px #fde6e8;
}
.cut-word{
  max-width: 25em !important;
}`, "",{"version":3,"sources":["webpack://./src/app/views/blogs-articles/add-edit-blog/add-edit-blog.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,4BAA4B;EAC5B,mCAAmC;EACnC,WAAW;EACX,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,mEAAmE;AACrE;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".thumbnail {\r\n  text-align: center;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  cursor: pointer;\r\n  margin: auto;\r\n}\r\n\r\n.folder-section .thumbnail {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  text-align: left;\r\n}\r\n\r\n.thumbnail:hover {\r\n  font-weight: 600;\r\n}\r\n\r\n.thumbnail:hover .media-delete {\r\n  opacity: 1;\r\n}\r\n\r\n.folder-section .thumbnail .thumbnail-icon {\r\n  margin-top: 1rem;\r\n  color: #fff;\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 70%;\r\n}\r\n\r\n.thumbnail .media-delete {\r\n  position: absolute;\r\n  right: 0.75rem;\r\n  opacity: 0;\r\n  transition: all ease-in-out 0.2s;\r\n  background: white;\r\n  border-radius: 0 50px 50px 0;\r\n  box-shadow: 2px 1px 2px 0px #cecece;\r\n  right: 18px;\r\n  top: 0;\r\n}\r\n\r\n.thumbnail .thumbnail-image {\r\n  flex-grow: 1;\r\n  max-width: 100%;\r\n  object-fit: cover;\r\n  border: 2px solid #fff;\r\n  border-bottom: none;\r\n  background: #fff;\r\n  padding: 0.25rem;\r\n  height: 130px;\r\n  width: 130px;\r\n}\r\n\r\n.thumbnail .thumbnail-text {\r\n  margin: 0;\r\n  padding: 0.25rem 1rem;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  color: #fff;\r\n  height: 3em;\r\n}\r\n\r\n.files-section .thumbnail .thumbnail-text {\r\n  color: black;\r\n}\r\n\r\n.folder-section {\r\n  background: #343a40;\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  top: 55px;\r\n  right: 0;\r\n}\r\n\r\n.menu-text {\r\n  color: #fff;\r\n}\r\n\r\n.add-new-comp {\r\n  background: #7e55b3;\r\n  border: 0px !important;\r\n  padding: 0.5em !important;\r\n  width: 100%;\r\n  color: #fff;\r\n  border-radius: 10px;\r\n}\r\n\r\n.folder-icon {\r\n  font-size: 24px;\r\n}\r\n\r\n.folder-delete {\r\n  display: inline-block;\r\n  float: right;\r\n  padding: 20px;\r\n}\r\n\r\n.folder-delete>i {\r\n  color: white;\r\n}\r\n\r\n.plus-btn {\r\n  left: 9rem;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\r\n  /* border-top-width: 5px !important; */\r\n  padding: 0px !important;\r\n}\r\n\r\n.card-margin {\r\n  margin: 15px;\r\n}\r\n\r\n/* .custom-container{\r\n\r\n} */\r\n\r\n.mat-card {\r\n  padding: 0px;\r\n}\r\n\r\n.mat-card-actions, .mat-card-content, .mat-card-subtitle {\r\n  padding: 16px;\r\n  margin: 16px;\r\n}\r\n\r\n.custom-card-header {\r\n  background-color: #7e55b3;\r\n  color: white;\r\n  padding: 10px 0px 0px 10px;\r\n}\r\n\r\n.custom-title {\r\n  font-weight: bold;\r\n  font-size: 15px;\r\n}\r\n\r\n.dorp-zone-media {\r\n  border: 1px dashed rgb(0, 161, 255);\r\n  height: 120px;\r\n  width: 130px;\r\n  margin: 8px 30px 30px 30px;\r\n  overflow-x: inherit;\r\n  text-align: center;\r\n}\r\n\r\n.alert-warning {\r\n  color: #856404;\r\n  background-color: #f8d7da;\r\n  border-color: #f5c6cb;\r\n  WIDTH: fit-content;\r\n}\r\n\r\n \r\n::ng-deep .categories-tags ng-select.ng-invalid.ng-touched .ng-select-container {\r\n  border-color: #dc3545;\r\n  animation-name: flush;\r\n  animation-duration: 0.7s;\r\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px #fde6e8;\r\n}\r\n.cut-word{\r\n  max-width: 25em !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
